import { type ReactNode } from 'react';

interface CardWrapperProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'xl' | 'none';
}

export function CardWrapper({
  children,
  className = '',
  padding = 'lg',
}: CardWrapperProps) {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-5',
    lg: 'p-6',
    xl: 'p-8',
  };

  return (
    <div
      className={`bg-neut-bg-alt rounded-lg border border-neut-border shadow-sm ${paddingClasses[padding]} ${className}`}
    >
      {children}
    </div>
  );
}
